import { getStore } from "../../../api/services/storeService.js";
import {
  getTrackingOrder,
  getOrderHistory,
} from "../../../api/services/orderService.js";
import { getOrderStatus } from "../../../api/helpers/orderHelper";
import { interpolate } from "../../../api/helpers/stringHelper";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { DateTime } from "luxon";
import { logger } from "../../../api/Logger";
import { AppConfig } from "../../../../AppConfig.js";
import { orderTypeHelper } from "../../../api/helpers/orderTypeHelper";
export default {
  methods: {
    ...mapMutations(["setStoreLoaded", "setDeliveryAddress"]),
    ...mapActions(["loadFromStorage", "resetModal", "clearCart"]),
    beforeDestroyComponent() {
      if (this.timerId) {
        clearInterval(this.timerId);
      }
    },
    createdComponent() {
      var that = this;
      this.clearCart();
      getStore(this.selectedCompanyId ? this.selectedCompanyId : this.storeid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            that.store = doc.data();
          }
        })
        .catch((reason) => {
          logger.log(
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath
          );
        });
      //get order
      if (this.userid) {
        getTrackingOrder(
          this.userid,
          this.orderid,
          this.selectedCompanyId ? this.selectedCompanyId : this.storeid
        ).onSnapshot(
          (doc) => {
            if (doc.exists) {
              that.trackingOrder = doc.data();
              that.updateDisplayModel(that.trackingOrder);
            } else {
              getOrderHistory(
                this.userid,
                this.orderid,
                this.selectedCompanyId ? this.selectedCompanyId : this.storeid
              ).onSnapshot(
                (doc) => {
                  if (doc.exists) {
                    that.trackingOrder = doc.data();
                    that.updateDisplayModel(that.trackingOrder);
                  } else {
                    that.trackingOrder = null;
                  }
                },
                function (reason) {
                  logger.log(
                    reason.name,
                    reason.toString(),
                    that.$router.currentRoute.fullPath
                  );
                }
              );
            }
          },
          function (reason) {
            logger.log(
              reason.name,
              reason.toString(),
              that.$router.currentRoute.fullPath
            );
          }
        );
      }
    },
    continueShopping() {
      this.$router.push({
        name: "store",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    viewOrder() {
      const storeID = this.$route.params.storeid;
      const table = sessionStorage.getItem("table");
      this.resetModal();
      window.location.href = `${AppConfig.payAtTable}/${storeID}/?table=${table}`;
    },
    viewHistory() {
      this.$router.push({
        name: "orderhistory",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    backToCheckout() {
      this.loadFromStorage();
      if (this.trackingOrder.DeliveryAddress) {
        var address = {
          StreetAddress: this.trackingOrder.DeliveryAddress.Address,
          PostalCode: this.trackingOrder.DeliveryAddress.Postcode,
          CityTown: this.trackingOrder.DeliveryAddress.Suburb,
          State: this.trackingOrder.DeliveryAddress.State,
        };
        this.setDeliveryAddress(address);
      }
      if (this.cartItems.length == 0) {
        this.$router.push({
          name: "checkout",
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
            orderid: this.trackingOrder.UDID,
          },
        });
      } else {
        if (this.displayModel.status < 0) {
          if (this.displayModel.status === -2) {
            logger.log(
              "Action Retry Payment in Finalize",
              "Retry Payment Button is pressed",
              "/CompleteOrder",
              logger.LogType.Info
            );
          } else {
            logger.log(
              "Action Retry in Finalize",
              "Retry Button is pressed",
              "/CompleteOrder",
              logger.LogType.Info
            );
          }
        }

        this.$router.push({
          name: this.displayModel.status == -2 ? "checkout" : "store",
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
          },
        });
      }
    },
    updateDisplayModel(order) {
      this.displayModel.OrderType = order.OrderType;
      if (order.OrderType === 10 || order.OrderType === 2) {
        this.displayModel.orderMode = "message.checkoutDelivery";
      } else {
        this.displayModel.orderMode = "message.pickUp";
      }
      //update status
      this.displayModel.status = getOrderStatus(order);
      let dStatus = order.OnlineOrderDeliveryStatus || 0;
      if (dStatus > 0) {
        switch (dStatus) {
          case 1:
            this.displayModel.orderState = this.$t("message.pickedUp");
            break;
          case 2:
            this.displayModel.orderState = this.$t("message.enRoute");
            break;
          case 3:
            this.displayModel.orderState = this.$t("message.droppedUp");
            break;
          default:
            break;
        }
        return;
      }
      switch (this.displayModel.status) {
        case -3:
          if (this.isOrderFailed){
            this.displayModel.orderState = this.$t("message.orderFaild");
          }
          else this.displayModel.orderState = this.$t("message.orderRejected");
          break;
        case -2:
          this.displayModel.orderState = this.$t("message.paymentFaild");
          break;
        case -1:
          this.displayModel.orderState = this.$t("message.orderRejected");
          break;
        case 0:
          this.displayModel.orderState = this.$t("message.orderSent");
          break;
        case 3:
          this.displayModel.orderState = this.$t("message.orderSubmitted");
          break;
        case 1:
          this.displayModel.orderState = this.$t("message.beingPrepared");
          break;
        case 2:
          if (order.OrderType === 10 || order.OrderType === 2)
            this.displayModel.orderState = this.$t("message.onItsWay");
          else this.displayModel.orderState = this.$t("message.readyForPickup");
          break;
        case 4:
          this.displayModel.orderState = this.$t("message.orderCompleted");
          break;
        case 5:
          this.displayModel.orderState = this.$t("message.orderRefunded");
          break;
        case 6:
          this.displayModel.orderState = this.$t("message.orderCancelRequest");
          break;
      }
      if (order.OnlineOrderStatus >= 18 && order.OnlineOrderStatus <= 20) {
        this.displayModel.isPayLater = true;
      } else {
        this.displayModel.isPayLater = false;
      }

      if (this.isOrderFailed && !this.displayModel.status){
        this.displayModel.orderState = order.OnlineOrderStatusDescription || this.$t("message.orderFaild");
        this.displayModel.status = -3
      }

    },
    updateStatus(statusDesc) {
      this.displayModel.orderState = statusDesc;
    },
    formatDate(date) {
      if (date) {
        var jsDate = new Date(date.seconds * 1000);
        var cDate = DateTime.fromJSDate(jsDate);
        return cDate.toFormat("dd MMMM yyyy h:mm a");
      } else {
        return "";
      }
    },
    isDelivery() {
      return orderTypeHelper.isDelivery() || (this.trackingOrder && this.trackingOrder.OrderType === 10);
    }
  },
  computed: {
    ...mapGetters([
      "cartItems",
      "checkLocalCartItemsExists",
      "viewConfig",
      "payTableEnabled",
    ]),
    isTwoColumn() {
      return this.store.IsDisableStatusTracking;
    },
    estimatedPickupDeliveryTimeLabel() {
      return interpolate(
        this.$t("message.estimatedPickupDeliveryTime"),
        this.$t(this.displayModel.orderMode)
      );
    },
    isOrderFailed() {
      if (
        this.trackingOrder.OnlineOrderStatusDescription ||
        this.trackingOrder.OnlineOrderStatusDescription.indexOf(
          "We’re having problems reaching the store"
        ) > -1
      ) {
        return true;
      }
      return false;
    },
    isDoorDash() {
      return !!this.trackingOrder.DoorDashDeliveryId;
    },
    dStatus() {
      return this.trackingOrder.OnlineOrderDeliveryStatus || 0;
    },
    getEndTime() {
      return this.trackingOrder.timeslotRangeEnd
        ? " - " + this.trackingOrder.timeslotRangeEnd
        : "";
    },
    estimeatedTimeText() {
      let output = this.formatDate(this.trackingOrder.ScheduledTime);
      if (this.trackingOrder.OrderType == 10) {
        // Delivery
        output = output.concat(this.getEndTime);
      }
      return output;
    },
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
    storeTable() {
      return sessionStorage.getItem("table");
    },
  },
};
